import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Header from "../components/section/header"
import { PortableText } from "@portabletext/react"
import { GatsbyImage } from "gatsby-plugin-image"
import Enquire from "../components/property/enquire"

export default function Page({ pageContext: { data }, location }) {
  const image = data.cover
  const metaImage = {
    src: image.asset.url,
    width: image.asset.metadata.dimensions.width,
    height: image.asset.metadata.dimensions.height,
  }
  return (
    <Layout>
      <Seo
        image={metaImage}
        title={data.name}
        description={data.shortDescription}
        pathname={location.pathname}
      />
      <Header
        title={data.name}
        image={
          <GatsbyImage
            image={image.asset.gatsbyImageData}
            className="h-full w-full object-cover animate"
            alt={data.name}
          />
        }
      />
      {data.images !== 0 && (
        <div className="pt-12 md:pt-20 max-w-5xl w-11/12 xl:w-full mx-auto grid gap-1">
          <ul className="grid md:grid-cols-3 gap-4">
            {data.images.map((col, key) => {
              return (
                <li key={key}>
                  <GatsbyImage
                    image={col.asset.gatsbyImageData}
                    alt={`${data.name}-1`}
                    className="aspect-video"
                  />
                </li>
              )
            })}
          </ul>
        </div>
      )}

      <Content description={data._rawDescription} name={data.name} />
    </Layout>
  )
}

const Content = ({ description, name }) => {
  return (
    <section className="py-12 md:py-20 max-w-5xl w-11/12 xl:w-full mx-auto">
      <div>
        <div className="flex flex-col gap-2 prose prose-h3:text-xl lg:prose-2xl prose-a:px-5 prose-a:py-2 prose-a:bg-stone-800 prose-a:text-white prose-a:no-underline prose-a:text-xs prose-a:tracking-widest prose-a:uppercase prose-a:rounded-md prose-p:text-lg prose-p:leading-10 mx-auto">
          <PortableText value={description} />
          {name === "Hotels On Sale" && (
            <div>
              <Enquire />
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
